export default __webpack_public_path__ + "svg/banner/ceo.svg?26a3d633";